import HttpClient from './http-client';
import instance from './instanceAuth2';

const newInstance = (resource: string, baseUrl?: string) =>
  new HttpClient(resource, baseUrl, instance as any);

export default newInstance;
